export const hiddenNudgeProps = {
	hidden: true,
	// Replace with lodash/noop
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	setHidden: () => {},
} as const;
